import { InputNumber } from "primereact/inputnumber";
import Helpers from "../../utils/helpers";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";

const CreateInvoiceTotal = (props: any) => {
  const { t } = useTranslation();
  const [disAmt, setDisAmt] = useState<number>(0);
  const [totalAmount, setTotalAmount] = useState<number>(0);

  const calculateTotal = () => {
    const baseTotal = props.taxableAmount + props.taxAmount +
      (props.orderedItems.orderInvoice.length > 0 ? 0 : props.orderedItems.handlingCharges + props.orderedItems.courierCharges + props.orderedItems.packingCharges + props.orderedItems.paymentGatewayCharges ) - disAmt;
    return baseTotal;
  };

  useEffect(() => {
    setTotalAmount(calculateTotal());
  }, [disAmt]);

  const handleUpdateDiscount = (value: number) => {
    setDisAmt(value);
    props.updateDiscountAmount(value);
  };

  // Helper function to format address with proper line breaks and without unnecessary commas
  const formatAddress = () => {
    const {
      address1,
      address2,
      landmark,
      areaName,
      subDistrictName,
      districtName,
      stateName,
      zipcode
    } = props.orderedItems;

    // First line components
    const line1Parts = [
      address1,
      address2,
      landmark
    ].filter(Boolean);

    // Second line components (area and sub-district)
    const line2Parts = [
      areaName,
      subDistrictName,
      districtName
    ].filter(Boolean);

    // Third line components (district, state, and pin)
    const line3Parts = [
      stateName,
      zipcode && `Pin: ${zipcode}`
    ].filter(Boolean);

    return (
      <>
        {line1Parts.length > 0 && <>{line1Parts.join(", ")}</>}
        {(line2Parts.length > 0 || line3Parts.length > 0) && (
          <>
            <br />
            {line2Parts.length > 0 && line2Parts.join(", ")}
            {line3Parts.length > 0 && (
              <>
                {line2Parts.length > 0 && ", "}
                {line3Parts.join(", ")}
              </>
            )}
          </>
        )}
      </>
    );
  };

  return (
    <div className="flex flex-wrap align-items-left justify-content-between px-3">
      <div className="col-12 md:col-6 lg:col-6">
        <label style={{ color: 'green' }}>{t("generateInv_shipping_add")}: </label>
        <p>{formatAddress()}</p>
      </div>
      <div className="col-12 md:col-6 lg:col-6 ">
        {/* Rest of your component remains the same */}
        <div className="flex flex-wrap">
          <div className="col-6 md:col-6 lg:col-6">
            <p className="m-1" style={{ lineHeight: "1.5" }}>{t("ordersummary_total_items_cost")} :</p>
            <p className="m-1" style={{ lineHeight: "1.5" }}>{t("ordersummary_tax")} :</p>
            <p className="m-1" style={{ lineHeight: "1.5" }}>Delivery Handling :</p>
            <p className="m-1" style={{ lineHeight: "1.5" }}>{t("couriercharge__Breadcrumb_label")} :</p>
            <p className="m-1" style={{ lineHeight: "1.5" }}>Packing Charges :</p>
            <p className="m-1" style={{ lineHeight: "1.5" }}>Payment Gateway :</p>
            <p className="m-1" style={{ lineHeight: "1.5" }}>Discount Amount :</p>
            <p className="m-1 font-semibold text-green font-bold" style={{ lineHeight: "1.5" }}>{t("ordersummary_total")} :</p>
          </div>
          <div className="col-6 md:col-6 lg:col-6 text-right">
            <p className="m-1" style={{ lineHeight: "1.5" }}>{Helpers.formatAmountInINR(props.taxableAmount)}</p>
            <p className="m-1" style={{ lineHeight: "1.5" }}>{Helpers.formatAmountInINR(props.taxAmount)}</p>
            <p className="m-1" style={{ lineHeight: "1.5" }}>
              {props.orderedItems.orderInvoice.length > 0 ? Helpers.formatAmountInINR(0) : Helpers.formatAmountInINR(props.orderedItems.handlingCharges)}
            </p>
            <p className="m-1" style={{ lineHeight: "1.5" }}>
              {props.orderedItems.orderInvoice.length > 0 ? Helpers.formatAmountInINR(0) : Helpers.formatAmountInINR(props.orderedItems.courierCharges)}
            </p>
            <p className="m-1" style={{ lineHeight: "1.5" }}>
              {props.orderedItems.orderInvoice.length > 0 ? Helpers.formatAmountInINR(0) : Helpers.formatAmountInINR(props.orderedItems.packingCharges)}
            </p>
            <p className="m-1" style={{ lineHeight: "1.5" }}>
              {props.orderedItems.orderInvoice.length > 0 ? Helpers.formatAmountInINR(0) : Helpers.formatAmountInINR(props.orderedItems.paymentGatewayCharges)}
            </p>
            <InputNumber 
              inputId="inputDisAmt" 
              value={disAmt} 
              onChange={(e: any) => { handleUpdateDiscount(e.value) }} 
              minFractionDigits={2} 
              locale="en-IN" 
            />
            <p className="m-1 font-semibold text-green font-bold" style={{ lineHeight: "1.5" }}>
              {Helpers.formatAmountInINR(Math.round(totalAmount))}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateInvoiceTotal;